import { Middleware } from 'redux';
import { isRSAA, RSAA } from 'redux-api-middleware';
import { CMS_API } from 'store/api';
import { State } from 'store/state/state.types';
import { ModeType } from 'theme/Theme.types';

export const createModeMiddleware =
  (appMode: ModeType): Middleware<{}, Pick<State, 'locale'>> =>
  store =>
  next =>
  action => {
    if (typeof action !== 'object' || action === null || !isRSAA(action)) {
      return next(action);
    }

    const apiCall = action[RSAA];
    const localeState = store.getState().locale;

    return next({
      [RSAA]: {
        ...apiCall,
        endpoint:
          apiCall.api === CMS_API
            ? `content/${appMode.toLowerCase()}/${localeState && localeState.locale ? localeState.locale : 'en'}/${
                apiCall.endpoint
              }.json`
            : apiCall.endpoint,
      },
    });
  };
